import { CommandSearch } from '@mxa-argos/components/custom/command-search';
import { SidebarTrigger } from '@mxa-argos/components/shadcn/sidebar';
import { SystemStatusIndicator } from '@mxa-argos/modules/system-status/components/system-status-indicator';
import { useTranslation } from 'react-i18next';

export const Header: React.FC = () => {
  const { t } = useTranslation();

  return (
    <header className="relative flex h-14 shrink-0 items-center gap-4 border-b bg-background px-4">
      <SidebarTrigger aria-label={t('common.toggleSidebar')} />

      <div className="hidden md:flex fixed left-1/2 -translate-x-1/2">
        <CommandSearch />
      </div>

      <div className="ml-auto flex items-center">
        <SystemStatusIndicator />
      </div>
    </header>
  );
};
